export enum AxiosResponseType {
  BLOB = 'blob',
  JSON = 'json'
}
